import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { isNumber } from 'helper';
import * as action from '../action';
import * as c from '../constant';

function ChangePinModal({
  updating,
  taxpayers,
  taxpayerId,
  setFormData,
  formData,
  changePin,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    login_pin: 'required',
  });

  const updateData = () => {
    showTransaction(taxpayerId);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    changePin(taxpayerId, formData, () => {
      setModal({ isOpen: false });
      updateData();
    });
  };

  const OnSetFormData = () => {
    setFormData({
      login_pin: taxpayers.attributes.login_pin || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(taxpayers)) {
      OnSetFormData();
    }
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [
    Object.keys(formData).join(','),
    Object.values(formData).join(','),
  ]);

  const handleChange = ({ target }) => {
    if (isNumber(target.value)) {
      setFormData({
        ...formData,
        login_pin: target.value
      })
    }
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Pin: {validateForm.renderMessage('login_pin')}
            </label>
            <input
              min="1"
              maxLength="4"
              className="form-control"
              type="tel"
              name="login_pin"
              onChange={handleChange}
              value={_.get(formData, 'login_pin') || ''}
              autoComplete="off"
            />
          </div>
        </div>

        <hr />

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3 "
          >
            <span className="font-weight-bold">Close</span>
          </button>
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ChangePinModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  taxpayerId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  //   history: PropTypes.instanceOf(Object).isRequired,
  changePin: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CHANGE_PASSWORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ChangePinModal);
